import { urls } from "../../urls";

const fetchConfirmPrenotificationData = async (subscriptionId: string, username: string) => {
    const rapbackUrl = urls.RAPBACK
    const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/confirm/${subscriptionId}?username=${username}`;
    try {
        return await fetch(url, {
            method: "POST",
            credentials: "include"
        })
    } catch (err: any) {
        console.error('error querying rapback confirm Prenotification: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchConfirmPrenotificationData